<template>
  <div v-if="datas!=null" class="tXimaFanshuiParentDiv" :style="{
    backgroundColor: HNewGameUIConfig.newGameUIType === 3 ?'#1f1f1f':'white',
  }">
    <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;">
      <div style="display: flex;flex-direction: row;align-items: center;">
        <div :style="hcf.getTextStyle({

      })">
          今日总计返水:
        </div>
        <div :style="hcf.getTextStyle({
        color:'main',marginLeft:5,addSize:1
      })">
          {{ datas["TodayTotalRebate"] }}
        </div>
      </div>
      <div style="display: flex;flex-direction: row;align-items: center;">
        <HRotateImg :clickImg="updateDatas" :width="20">
          <template #right>
            <div :style="hcf.getTextStyle({
                color:'main',marginLeft:5,
              })">
              刷新
            </div>
          </template>
        </HRotateImg>
      </div>
    </div>
    <van-divider style="margin:10px"/>
    <div style="margin-bottom: 5px;display: flex;flex-direction: row;align-items: center;">
      <div :style="hcf.getTextStyle({

      })">
        今日已领取返水:
      </div>
      <div :style="hcf.getTextStyle({
        color:'main',marginLeft:5,addSize:1
      })">
        {{ datas["TodayGetRebate"] }}
      </div>
    </div>
    <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;">
      <div style="display: flex;flex-direction: row;align-items: center;">
        <div :style="hcf.getTextStyle({

      })">
          {{ datas["RebateTips"] != null && datas["RebateTips"] !== "" ? datas["RebateTips"] : "今日可领取返水:" }}
        </div>
        <div :style="hcf.getTextStyle({
        color:'#E08900',marginLeft:5,addSize:1
      })">
          {{ datas["TodayCanRebate"] }}
        </div>
      </div>
      <div @click="clickGetRebate" :style="{
        borderRadius:'6px',
        backgroundColor:isCanPressGetBtn
                                ? hcf.getMainColor()
                                : HNewGameUIConfig.newGameUIType === 3?'#555':'#3332',
        padding:'3px 8px',
      }">
        <div :style="hcf.getTextStyle({
          addSize:-1,color:isCanPressGetBtn? 'white': HNewGameUIConfig.newGameUIType === 3?'#999':'#3336'
      })">
          立即领取
        </div>
      </div>
    </div>
    <div :style="hcf.getTextStyle({
      addSize:-2,marginTop:(datas['YesterdayCanRebate']??'') === ''?0:3,color:'#999'
    })">{{datas["YesterdayCanRebate"]??''}}</div>
    <van-divider style="margin:10px"/>
    <div style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;justify-content: flex-start;">
      <img :src="allFrontVipLevel[user.vipLevel]" :style="{
        width:'95px',
        height:90/297*95+'px',
      }" alt="">
      <div style="display: flex;flex-direction: column;align-items:  flex-start;">
        <div style="display: flex;flex-direction: row;">
          <div :style="hcf.getTextStyle({
        color:'#8A604B',marginLeft:5,addSize:-1
      })">
            当前VIP最高返水比例:
          </div>
          <div :style="hcf.getTextStyle({
        color:'main',marginLeft:5,addSize:-1
      })">
            {{datas["VipRebateRate"]}}
          </div>
        </div>
        <div @click="hr.go('vip-detail');" :style="hcf.getTextStyle({
        color:'#aaa',marginLeft:5,addSize:-1,textDecoration:'underline'
      })">
         查看返水比例
        </div>
      </div>
    </div>
    <div style="background-color: var(--ct-main-bg-color)">
      <HTable :targetColumnIndex="3" targetColumnIndexColor="#E08900" :tabData='{
        "header":["游戏类型", "有效投注额", "最高返水率", "返水金额"],
        "list": datas["TodayRebateTable"] ?? [],
      }'/>
    </div>
    <van-divider style="margin:10px"/>
    <div :style="hcf.getTextStyle({
          fontWeight:'bold',color: 'main',
      })">领取说明
    </div>
    <div v-for="eachRemark in datas['GetRules']" :key="eachRemark">
      <div :style="hcf.getTextStyle({
            addSize:-1,
        })">
        {{eachRemark}}
      </div>
    </div>
    <van-divider style="margin:10px"/>
    <div :style="hcf.getTextStyle({
          fontWeight:'bold',color: 'main'
      })">洗码说明
    </div>
    <div v-for="eachRemark in datas['RebateRules']" :key="eachRemark">
      <div :style="hcf.getTextStyle({
            addSize:-1,
        })">
        {{eachRemark}}
      </div>
    </div>
  </div>
</template>


<script setup>
  import {useUserStore} from "@/stores/useUser.js";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import {hcf} from "@/components/utils/HComFunctions.js";
  import HRotateImg from "@/components/utils/HRotateImg.vue";
  import {showToast} from "vant";
  import front_vip_lelve_0 from "@/assets/icons/vip/front_vip_lelve_0.png";
  import front_vip_lelve_1 from "@/assets/icons/vip/front_vip_lelve_1.png";
  import front_vip_lelve_2 from "@/assets/icons/vip/front_vip_lelve_2.png";
  import front_vip_lelve_3 from "@/assets/icons/vip/front_vip_lelve_3.png";
  import front_vip_lelve_4 from "@/assets/icons/vip/front_vip_lelve_4.png";
  import front_vip_lelve_5 from "@/assets/icons/vip/front_vip_lelve_5.png";
  import front_vip_lelve_6 from "@/assets/icons/vip/front_vip_lelve_6.png";
  import front_vip_lelve_7 from "@/assets/icons/vip/front_vip_lelve_7.png";
  import front_vip_lelve_8 from "@/assets/icons/vip/front_vip_lelve_8.png";
  import front_vip_lelve_9 from "@/assets/icons/vip/front_vip_lelve_9.png";
  import front_vip_lelve_10 from "@/assets/icons/vip/front_vip_lelve_10.png";
  import {hr} from "@/components/utils/HRouter.js";
  import HTable from "@/components/utils/HTable.vue";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";

  const allFrontVipLevel = [
    front_vip_lelve_0,
    front_vip_lelve_1,
    front_vip_lelve_2,
    front_vip_lelve_3,
    front_vip_lelve_4,
    front_vip_lelve_5,
    front_vip_lelve_6,
    front_vip_lelve_7,
    front_vip_lelve_8,
    front_vip_lelve_9,
    front_vip_lelve_10
  ];

  const user = useUserStore();
  const http = useHHttp();
  const datas = ref();
  const isCanPressGetBtn = ref(false);

  function clickGetRebate() {
    if (isCanPressGetBtn.value) {
      http.request("/app/rebate/award/get", () => {
        showToast("领取成功");
        updateDatas();
      }, {loadingDelayMillTime: 0});
    }
  }

  function updateDatas() {
    http.request("/app/rebate/today", (resp) => {
      if ("VipLevel" in resp) {
        user.vipLevel = resp["VipLevel"];
      }
      datas.value = resp;
      isCanPressGetBtn.value = parseFloat(datas.value["TodayCanRebate"] ?? "0.00") > 0;
    });
  }

  onMounted(() => {
    updateDatas();
  });

</script>


<style scoped>

  .tXimaFanshuiParentDiv {
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    padding: 10px;
  }

</style>
